import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// compas
import { base64urlDecode } from "./Base64URL";
import "./compas.scss";

const RiskProfile = (props) => {
  const [graphSrc, setGraphSrc] = useState("");
  const location = useLocation();
  const { id, username, email } = useParams();

  const decodedId = id ? base64urlDecode(id) : "ID not provided";

  console.log(decodedId);
  const [heading, setHeading] = useState("");
  const [Riskheading, setRiskheading] = useState("");
  const [message, setMessage] = useState("");
  const [messagecoler, setMessagecoler] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    switch (decodedId) {
      case "1":
      case "2":
      case "3":
        setMessagecoler();
        setRiskheading("Conservative");
        setGraphSrc("../../assets/images/graph/1.svg");
        setHeading("You are a Conservative Investor!");
        setMessage(
          "Your top priority is capital preservation. You are willing to accept minimal risks and, therefore, are prepared for lower potential returns on your investments. "
        );
        break;
      case "4":
      case "5":
      case "6":
      case "7":
        setRiskheading("Moderate");
        setMessagecoler();
        setGraphSrc("../../assets/images/graph/4.svg");
        setHeading("You are a Moderate Investor!");
        setMessage(
          "You are comfortable with a balance between risk and reward. You are willing to accept moderate levels of risk in exchange for the potential for higher returns over the medium to long term."
        );
        break;
      case "8":
      case "9":
      case "10":
        setMessagecoler();
        setRiskheading("Aggressive");
        setGraphSrc("../../assets/images/graph/8.svg");
        setHeading("You are an Aggressive Investor!");
        setMessage(
          "You are willing to take on significant risk to maximize your potential returns over the long term. This aggressive investment style could lead to higher returns, but also carries the potential for larger losses."
        );
        break;
      default:
        setGraphSrc("");
        setHeading("");
        setMessage("");
        setMessagecoler();

        break;
    }
  }, [props]);
  // State to hold the value of the range input
  const [value, setValue] = useState(4);

  // Handler function to update state when input value changes
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const reCalculate = () => {
    navigate(`/RiskAnalyzerCalculate/${email}/${username}`);
  };
  const returnToHome = () => {
    navigate("/RiskAnalyser");
  };
  return (
    <div className="RiskProfilediv container">
      <h1
        id="idRiskhead"
        className={
          Riskheading == "Conservative"
            ? "Conservativediv"
            : Riskheading == "Moderate"
            ? "Moderatediv"
            : Riskheading == "Aggressive"
            ? "Aggressivediv"
            : null
        }
      >
        {Riskheading}
      </h1>

      <input
        className="inputrange"
        id=""
        type="range"
        min="1"
        max="10"
        step="1"
        value={decodedId}
        onChange={handleChange}
        style={{ width: "100%" }}
      />
      <div class="GraphDivbackground">
        <span className={decodedId == 1 ? "Graphscor" : "GraphscorDis"}>
          {" "}
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">1</p>
        </span>
        <span className={decodedId == 2 ? "Graphscor" : "GraphscorDis"}>
          {" "}
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">2</p>
        </span>
        <span className={decodedId == 3 ? "Graphscor" : "GraphscorDis"}>
          {" "}
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">3</p>
        </span>
        <span className={decodedId == 4 ? "Graphscor" : "GraphscorDis"}>
          {" "}
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">4</p>
        </span>
        <span className={decodedId == 5 ? "Graphscor" : "GraphscorDis"}>
          {" "}
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">5</p>
        </span>
        <span className={decodedId == 6 ? "Graphscor" : "GraphscorDis"}>
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">6</p>
        </span>
        <span className={decodedId == 7 ? "Graphscor" : "GraphscorDis"}>
          {" "}
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">7</p>
        </span>
        <span className={decodedId == 8 ? "Graphscor" : "GraphscorDis"}>
          {" "}
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">8</p>
        </span>
        <span className={decodedId == 9 ? "Graphscor" : "GraphscorDis"}>
          {" "}
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">9</p>
        </span>
        <span className={decodedId == 10 ? "Graphscor" : "GraphscorDis"}>
          {" "}
          <p className="Graphscordiv"></p>
          <p className="Graphscortext">10</p>
        </span>
      </div>
      {/*       
      <div className="GraphDiv">
        <div className="Graphbardiv"></div>
        

        <div className="Graphbar">
          <div
            className={
              id == 1 || id == 2 || id == 3
                ? `GraphbarConservative`
                : "GraphbarConservative Graphbarnone"
            }
          >
            <div className={`GraphbarConservative_${id}`}>
              <div className="Graphin">
                <div className="Graphscor">{id}</div>
              </div>{" "}
            </div>
          </div>
          <div
            className={
              id == 4 ||
              id == 5 ||
              id == 6 ||
              id == 7
                ? `GraphbarModerate `
                : "GraphbarModerate Graphbarnone"
            }
          >
            <div className={`GraphbarModerate_${id}`}>
              <div className="Graphin">
                <div className="Graphscor">{id}</div>
              </div>{" "}
            </div>
          </div>
          <div
            className={
              id == 8 || id == 9 || id == 10
                ? `GraphbarAggressive`
                : "GraphbarAggressive Graphbarnone"
            }
          >
            <div className={`GraphbarAggressive_${id}`}>
              {" "}
              <div className="Graphin">
                <div className="Graphscor">{id}</div>
              </div>{" "}
            </div>
          </div>
        </div>
      </div> */}
      <h1
        id="idhead"
        className={
          Riskheading == "Conservative"
            ? "Conservativediv"
            : Riskheading == "Moderate"
            ? "Moderatediv"
            : Riskheading == "Aggressive"
            ? "Aggressivediv"
            : null
        }
      >
        {heading}
      </h1>
      <p id="idMsg">{message}</p>
      <div className="quiz-questions">
        <div className="quiz-btns">
          <button className="quiz-prev-btn" onClick={reCalculate}>
            <i className="fa fa-chevron-left"></i> Calculate again
          </button>
          <button
            className="risk-next-btn"
            onClick={returnToHome}
            // disabled={selectedOption === null}
          >
            Back to Home
            {/* <i className="fa fa-chevron-right"></i> */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RiskProfile;
